import Component from '../Component';

class NestedControlBlock extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount() {
		this.children.forEach((child) => {
			child.setRefs(this.refs);
			child.componentDidMount();
		});
	}

	render() {
		return (`
            <div class="layerPanel__control ${this.props.className ?? ''}">
                ${this.children.map((child) => {
				return child.render();
			}).join('')}
            </div>`
		);
	}
}

export default NestedControlBlock;